import React, { useState } from 'react'
import './Todo.css'

function Todo() {
const [input,setInput]=useState('')
const [todoList,setTodoList]=useState([])

const handleChange=(e)=>{
    setInput(e.target.value)
}

const addTask=()=>{
    setTodoList([...todoList,{id:Date.now(),text:input,done:false}])
    setInput('')
}
const handleDone=(taskid)=>{

const tempData=todoList.map((element)=>{
    if(element.id===taskid){
        element.done=!element.done

    }
  return element  
})
setTodoList(tempData)
}

  return (
    <div className='todo-box'>
        <h2>TODO APP</h2>
        <div className="inputbox">
        <input type='text' onChange={handleChange} placeholder='task to do' value={input}/>
        <button onClick={addTask}>ADD</button>
        </div>
        
            <ul className="listbox">
                {todoList.map((task,index)=>{

                    return (
                    <span  key={task.id} className="listitems">
<li>{index+1} {task.text}</li>
<div className='checkstatus'>
<p>{task.done? 'Done':'Pending'}</p>
<input type="checkbox" onChange={()=>handleDone(task.id)}/>
</div>

                    </span>
                    
                    
                    ) 
                })}
            </ul>
        
        
    </div>
  )
}

export default Todo